export function obfuscatePhone(phone = "") {
  return (
    phone.slice(0, 3) + // Первые три символа
    "*".repeat(phone.length - 7) + // Маскируем символы между
    phone.slice(-4) // Последние четыре символа
  );
}
